import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__settings_user_tab } from '@/pages/+settings/user/_base/ENUM__settings_user_tab';
import { ESettingsWorkspaceTab } from '@/pages/+settings/workspace/ESettingsWorkspaceTab';
import { ENUM__local_event } from '@/services/events/ENUM__local_event';
import { service_local_events } from '@/services/events/service_local_events';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function WatcherResponseLowBalance() {
  const { t } = useTranslation([ENUM__i18n_namespace.ERRORS, ENUM__i18n_namespace.BASE_UI]);

  const dispatch = use_dispatch();

  const navigate = useNavigate();
  const { toast } = useToast();

  const { user_id } = use_slice_user(['user_id']);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    service_local_events.on(ENUM__local_event.RESPONSE_LOW_BALANCE_RECEIVED, on_response_received);

    return () => service_local_events.off(ENUM__local_event.RESPONSE_LOW_BALANCE_RECEIVED, on_response_received);
  });

  /*
   * EVENTS
   */
  async function onClick() {
    dispatch(
      LOCAL__ui_set_string({
        key: 'page_settings_user_current_tab',
        value: ESettingsWorkspaceTab.CREDITS_TOP_UP,
        valid_values: Object.values(ENUM__settings_user_tab),
      }),
    );

    await navigate(ENUM__page_type.SETTINGS_USER, { replace: true });
  }

  function on_response_received() {
    let action = undefined;

    if (user_id == workspace_current.user_id_owner) {
      action = (
        <UI_PRIMITIVE__button variant="outline-on-bar" {...{ onClick }}>
          {t(i18n_base_ui.toasts.response_low_balance.action.button.open_top_up_credits_window)}
        </UI_PRIMITIVE__button>
      );
    }

    toast({ title: t(i18n_base_ui.toasts.response_low_balance.title), action });
  }

  return null;
}
